import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreHeading,
  OreStack,
  OreText,
  SvgCheck,
  SvgDownload,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentDocumentModel } from '@/AutoEnrollment/domain'
import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { textToPdf } from '@/Shared/domain'

export const ContractNewProductsStep3Documents = (): JSX.Element => {
  const { t } = useTranslation()
  const {
    documents: { documents, setIsDownloaded, dowloadedDocuments },
  } = useContractNewProducts()

  const documentButton = (
    documentToSign: AutoEnrollmentDocumentModel,
    i: number,
  ): JSX.Element => {
    const isDownloaded = dowloadedDocuments.find(
      d => d.signingId === documentToSign.signingId,
    )?.signed

    return (
      <OreButton
        key={`document-to-sign-${i}`}
        onClick={() => {
          textToPdf(
            documentToSign.documentContent,
            documentToSign.documentName.split('.').slice(0, -1).join('.'),
          )
          setIsDownloaded(documentToSign.signingId)
        }}
        icon={isDownloaded ? <SvgCheck /> : <SvgDownload />}
      >
        {documentToSign.documentName.split('.').slice(0, -1).join('.')}
      </OreButton>
    )
  }

  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack space="large">
          <OreHeading size="headline-md">
            {t(
              productContractingTranslation.contractProductPage.step3.signDocuments.title,
            )}
          </OreHeading>
          <OreText>
            {t(
              productContractingTranslation.contractProductPage.step3.signDocuments
                .description,
            )}
          </OreText>
          <OreStack placeItems="start">
            {documents?.documentsForSigning?.map(
              (document: AutoEnrollmentDocumentModel, i: number) => {
                if (!document.needsSign) return null

                return documentButton(document, i)
              },
            )}
          </OreStack>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
